import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { convertirVEF } from '../../../../helpers/ConversionesHelper';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { allEntCarrerasAction } from '../../../entidad/ent_carreras/EntCarrerasAction';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allConceptosAction,
  deleteConceptosAction,
  setActivoConceptosAction,
} from '../ConceptosAction';
import { PARAMS_CONCEPTOS } from '../ConceptosReducer';

const ListadoConceptos = ({ isDelete = false, setIsDelete = () => {} }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entCarrerasStore = Redux.useSelector((state) => state.entCarreras);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const conceptosStore = Redux.useSelector((state) => state.conceptos);
  const entMonedasStore = Redux.useSelector((state) => state.entMonedas);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [columns, setColumns] = React.useState([]);

  React.useEffect(() => {
    async function fetchData() {
      const payload = {
        ...conceptosStore.params,
        idEntidad: entidadesStore.activo.id,
      };

      if (entCarrerasStore.all && entCarrerasStore.all.length === 0) {
        await allEntCarrerasAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }

      dispatch({ type: PARAMS_CONCEPTOS, payload });
      if (conceptosStore.all && conceptosStore.all.length === 0) {
        await allConceptosAction(dispatch, payload);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rowsData = [];
    conceptosStore.all.forEach((el) => {
      const cambios = {};
      entMonedasStore.all.forEach((item) => {
        if (item.cambio) {
          let total = 0.0;
          if (item.cambio.abrev === 'VEF') {
            total = convertirVEF(item.tasa, el.costo);
          }
          cambios[item.cambio.abrev] = total;
        }
      });
      rowsData.push({
        ...el,
        ...cambios,
      });
    });

    setRows(rowsData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conceptosStore.all]);

  const _handleEditClick = async (id) => {
    setIsDelete(false);
    const data = conceptosStore.all.find((el) => el.id === id);
    await setActivoConceptosAction(dispatch, data);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteConceptosAction(
      { dispatch, notify },
      conceptosStore.activo.id,
      conceptosStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  React.useEffect(() => {
    const columns = [
      {
        name: CONST.ID,
        options: {
          display: loginStore.isRoot ? false : 'excluded',
          filter: false,
        },
      },
      {
        name: CONST.codigo.name,
        label: CONST.codigo.label,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: CONST.nombre.name,
        label: CONST.concepto.label,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <Stack direction="row" alignItems="center">
                <NameComponent
                  onClick={() => _handleEditClick(tableMeta.rowData[0])}
                  mr="1em"
                >
                  {value}
                </NameComponent>
                {conceptosStore.activo?.id === tableMeta.rowData[0] && (
                  <Chip label="Editando" size="small" color="info" />
                )}
              </Stack>
            );
          },
        },
      },
      {
        name: CONST.costo.name,
        label: 'Costo en $ (USD)',
        options: {
          filter: true,
          sort: true,
        },
      },
    ];

    entMonedasStore.all.forEach((el) => {
      if (el.cambio) {
        columns.push({
          name: el.cambio.abrev,
          label: `Costo en ${el.cambio.simbolo} (${el.cambio.abrev})`,
          options: {
            filter: true,
            sort: true,
          },
          customBodyRender: (value, tableMeta, updateValue) => {
            return value;
          },
        });
      }
    });

    columns.push(
      ...[
        {
          name: CONST.estatus.name,
          label: CONST.estatus.label,
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <Tooltip
                  describeChild
                  title="Estatus del registro"
                  placement="left"
                >
                  <Chip
                    label={value.nombre}
                    size="small"
                    color={value.id === 1 ? 'success' : 'error'}
                  />
                </Tooltip>
              );
            },
          },
        },
        {
          name: CONST.actions.name,
          label: CONST.actions.label,
          options: {
            filter: false,
            sort: false,
            empty: true,
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <Stack direction="row">
                  <ActionsListWidget
                    id={tableMeta.rowData[0]}
                    onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                    onDelete={async () => {
                      setIsDelete(true);
                      const data = conceptosStore.all.find(
                        (el) => el.id === tableMeta.rowData[0],
                      );
                      await setActivoConceptosAction(dispatch, data);
                      setOpenModalDelete(true);
                    }}
                  />
                </Stack>
              );
            },
          },
        },
      ],
    );
    setColumns(columns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows]);

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={conceptosStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {conceptosStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">{conceptosStore.activo.nombre}</Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoConceptos;
